<template>
  <div>
    <navbar></navbar>
    <div class="container is-fullheight hero-body">
        <div class="columns is-centered">
            <div class="column is-6">
				        <login-logo></login-logo>
                <h3 class="title has-text-centered has-text-dark">Member Logout Page</h3>

                <button class="button is-dark is-large is-fullwidth" @click="doLogout()">
                    Yes
                </button>

                <button class="button is-dark is-large is-fullwidth" @click="doNothing()">
                    Cancel
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import LoginLogo from "./features/LoginLogo"

import Navbar from "./features/Navbar"
import { AUTH_LOGOUT, AUTH_RESTAPI } from "../store/actions/auth";

export default {
  name: 'Logout',
  data () {
    return {
    }
  },
  components: {
	Navbar,
  LoginLogo,
  },
  methods: {
	doLogout() {

  const { username, password } = this;
    this.$store.commit(AUTH_RESTAPI, this.$api.REST_API)

this.$store.dispatch(AUTH_LOGOUT, { username, password }).then(() => {
  this.$router.push("/");
  });
  },
  doNothing() {
  this.$router.back();
},
}
}
</script>

<style scoped>
.password-remind-link {
	margin-bottom: 10px;
}
.background-light {
	background-color: hsl(0, 0%, 96%);
}
</style>



// WEBPACK FOOTER //
// src/components/Logout.vue